module.exports = __webpack_public_path__ + "static/media/haute12A.b67ecda0.jpg";